import * as actionTypes from '../actionTypes';

export const getPrimarySources = function () {
  return { type: actionTypes.GET_PRIMARY_SOURCES };
};
